var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"copyright"},[_vm._v(" Copyright © "+_vm._s(_vm.$store.state.settings.copyrightDates)+" "),_c('component',_vm._b({},'component',_vm.linkProps(),false),[_vm._v(_vm._s(_vm.$store.state.settings.copyrightCompany))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }